/**
 * Messages for /relatorios (reports dashboard prototype).
 * pt-BR is the source of truth; en-US / es-ES satisfy the same keys.
 */

export const reportsDashboardPtBR = {
  classCompletion: {
    "title": "Atividades por aluno",
    "description": "Selecione uma turma, o período e as atividades que contam para a nota. Exporte uma única planilha com todos os alunos.",
    "class": "Turma",
    "period": "Período",
    "selectClass": "Selecione uma turma",
    "from": "Data inicial",
    "to": "Data final",
    "load": "Consultar atividades",
    "loading": "Carregando…",
    "invalidDates": "Informe datas válidas, com a data final igual ou posterior à inicial.",
    "error": "Não foi possível consultar as atividades. Tente novamente.",
    "emptyActivities": "Nenhuma atividade encontrada para esta turma no período.",
    "emptyStudents": "Esta turma não possui alunos.",
    "selectActivities": "Atividades incluídas na nota",
    "all": "Selecionar todas",
    "none": "Desmarcar todas",
    "selected": "{{selected}} de {{total}} atividades selecionadas",
    "export": "Exportar planilha Excel",
    "student": "Aluno",
    "completedCount": "Concluídos",
    "percentage": "Porcentagem",
    "completed": "Concluído",
    "notCompleted": "Não concluído",
    "statuses": "Conclusão",
    "progress": "Progresso",
    "exportError": "Não foi possível exportar a planilha. Tente novamente.",
    "criteria": "Alunos atualmente na turma. Atividades disponíveis no período ou realizadas nele. Missões: envios aprovados; quizzes: envios, inclusive discursivos. Trilhas e flashcards: conclusões registradas no período. Progresso da trilha: etapas concluídas no período ou conclusão final. Datas inclusivas, horário de Brasília. Conclusão não representa acerto ou nota.",
    "types": {
        "mission": "Missão",
        "quiz": "Quiz",
        "trail": "Trilha",
        "flashcard": "Flashcards",
        "flashcard_true_false": "Flashcards V/F",
        "content": "Conteúdo"
    }
},
  pageTitle: "Relatórios | Gamefik",

  seoDescription:
    "Acompanhe engajamento, turmas, professores, atividades e recompensas em um só lugar.",

  headerTitle: "Relatórios",
  subtitleGestor: "Visão completa da escola",
  subtitleProfessor: "Visão das suas turmas",
  modeGestor: "Gestor",
  modeProfessor: "Professor",
  export: "Exportar PDF",
  exportMenu: {
    currentTab: "Exportar aba atual",
    fullReport: "Relatório completo",
    exportDataLabel: "Exportar dados",
    generating: "Gerando PDF…",
    failed: "Não foi possível gerar o relatório completo porque uma das seções falhou.",
    generatedAt: "Gerado em {{date}}",
    filters: "Período: {{period}} • Turma: {{turma}}",
    columnPeriod: "Período",
    columnLevel: "Nível",
    columnCount: "Quantidade",
    exportCsvTooltip: "Exportar CSV: {{table}}",
  },

  periodLabel: "Período:",
  morePeriods: "Mais períodos",

  emptyState: {
    noDataPeriod: "Nenhum dado encontrado no período selecionado",
    refreshing: "Atualizando…",
  },

  classeTodasGestor: "Todas as turmas",
  classeTodasProfessor: "Todas as suas turmas",

  pagination: {
    range: "{{start}}-{{end}} de {{total}}",
  },

  tabs: {
    geral: "Geral",
    turmas: "Turmas",
    professores: "Professores",
    atividades: "Atividades",
    recompensas: "Recompensas",
  },

  viewModeGestorBadge: "Modo Gestor — vendo dados de toda a escola",
  viewModeProfessorBadge: "Modo Professor — vendo dados das suas turmas",

  granularity: {
    days: "dias",
    weeks: "semanas",
    months: "meses",
    quarters: "trimestres",
    bimesters: "bimestres",
  },

  legend: {
    access: "Acesso",
    conclusion: "Conclusão",
    accessRate: "Taxa de acesso",
    conclusionRate: "Taxa de conclusão",
  },

  period: {
    thisWeek: {
      label: "Esta semana",
      subtitle: "Esta semana (Seg–Qua)",
      comparison: "última semana",
      xAxis: "Seg|Ter|Qua",
    },
    thisMonth: {
      label: "Este mês",
      subtitle: "Abril 2026",
      comparison: "mês anterior",
      xAxis: "Sem 1|Sem 2",
    },
    thisTermBimester: {
      label: "Este bimestre",
      subtitle: "2º Bimestre 2026",
      comparison: "bimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5",
    },
    thisTermTrimester: {
      label: "Este trimestre",
      subtitle: "2º Trimestre 2026",
      comparison: "trimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5|Sem 6",
    },
    lastWeek: {
      label: "Última semana",
      subtitle: "Última semana (7–13 abr)",
      comparison: "semana anterior",
      xAxis: "Seg|Ter|Qua|Qui|Sex|Sáb|Dom",
    },
    lastMonth: {
      label: "Último mês",
      subtitle: "Março 2026",
      comparison: "mês anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4",
    },
    lastTermBimester: {
      label: "Último bimestre",
      subtitle: "1º Bimestre 2026",
      comparison: "bimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5|Sem 6|Sem 7|Sem 8",
    },
    lastTermTrimester: {
      label: "Último trimestre",
      subtitle: "1º Trimestre 2026",
      comparison: "trimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5|Sem 6|Sem 7|Sem 8|Sem 9|Sem 10|Sem 11|Sem 12",
    },
    thisSemester: {
      label: "Este semestre",
      subtitle: "1º Semestre 2026",
      comparison: "semestre anterior",
      xAxis: "Fev|Mar|Abr",
    },
    schoolYearBimester: {
      label: "Ano letivo",
      subtitle: "Ano letivo 2026",
      comparison: "ano anterior",
      xAxis: "1º Bi|2º Bi",
    },
    schoolYearTrimester: {
      label: "Ano letivo",
      subtitle: "Ano letivo 2026",
      comparison: "ano anterior",
      xAxis: "1º Tri|2º Tri",
    },
  },

  metric: {
    studentEngagementTitle: "Engajamento dos alunos",
    accessRate: "Taxa de acesso",
    completionRate: "Taxa de conclusão",
    noActivitiesInPeriod: "Sem atividades no período",
    completionSubtitle: "Atividades concluídas / atribuídas",
    avgFrequency: "Frequência média",
    avgFrequencySubtitle: "Acessos por semana / aluno",
    accessOfTotal: "{{access}} de {{total}} alunos acessaram",
  },

  section: {
    weeklyEvolution: "Evolução semanal",
    weeklyEvolutionSubtitle: "Taxa de acesso e conclusão por {{grain}}",
    studentEngagementDist: "Engajamento dos seus alunos",
    studentEngagementDistSubtitle: "Distribuição por nível de atividade no período",
    accessPerClassGestor: "Acesso por turma",
    accessPerClassSubtitleGestor:
      "Taxa de acesso de cada turma — identifica onde agir",
    accessPerClassSubtitleProfessor: "Taxa de acesso das suas turmas",
    noClassesForFilter: "Nenhuma turma encontrada para este filtro",
    studentsNeedAttention: "Alunos que precisam de atenção",
    studentsNeedAttentionSubtitle: "Nenhum acesso no período selecionado",
    topStudents: "Alunos destaque",
    topStudentsSubtitle: "Maior XP + atividades concluídas",
    highlightWeekTitle: "Destaques da semana",
    highlightWeekBody:
      "Reconhecer esses alunos publicamente reforça comportamento positivo e inspira colegas.",
    atRiskBannerTitle: "{{count}} alunos precisam de atenção",
    atRiskBannerBody:
      "Nenhum acesso no período selecionado. Uma mensagem personalizada pode reconectar esses alunos.",
    turmasComparison: "Comparativo entre turmas",
    turmasComparisonSubtitle: "Métricas-chave lado a lado",
    turmasEvolution: "Evolução por turma",
    turmasEvolutionSubtitle: "Taxa de acesso por {{grain}} de cada turma",
    studyTimeTitle: "Tempo médio de estudo por turma",
    studyTimeSubtitle: "Minutos por semana por aluno — ordenado por tempo",
    professorActivityTitle: "Atividade dos professores",
    professorActivitySubtitle:
      "Como cada professor está usando a plataforma no período",
    skillsHeroTitle: "Habilidades e conteúdos",
    skillsHeroBody:
      "Acompanhe quais conteúdos e habilidades você mais trabalhou com seus alunos. Identifique oportunidades de reforço e veja o desempenho por turma.",
    topContentsRadar: "Conteúdos mais trabalhados",
    topContentsRadarSubtitle: "Quantidade de atividades por conteúdo",
    performanceBySubject: "Desempenho por disciplina e turma",
    performanceBySubjectSubtitle: "Taxa de acerto média nas atividades",
    reinforcementTitle: "Conteúdos que precisam de reforço",
    reinforcementSubtitle: "Taxa de acerto abaixo de 60%",
    rankingByActivitiesTitle: "Conteúdos mais trabalhados",
    rankingByActivitiesSubtitle: "Ranking por quantidade de atividades",
    rewardsPerfTitle: "Desempenho das recompensas",
    rewardsPerfSubtitle: "Resgates, estoque e moedas gastas",
    openRewardOrdersTitle: "Pedidos de recompensas em aberto",
    openRewardOrdersSubtitle: "Solicitações que aguardam aprovação ou entrega",
    neverRedeemedTitle: "Alunos sem resgates no período",
    neverRedeemedSubtitleSingle:
      "{{count}} aluno ({{pct}}%) sem resgates no período",
    neverRedeemedSubtitlePlural:
      "{{count}} alunos ({{pct}}%) sem resgates no período",
    activitiesPerfTitle: "Desempenho das atividades",
    activitiesPerfSubtitle: "Todas as atividades do período",
    difficultQuizzesTitle: "Quizzes com dificuldade",
    difficultQuizzesSubtitle: "Quizzes com taxa de acerto abaixo de 70%",
  },

  disciplines: {
    historia: "História",
    geografia: "Geografia",
    portugues: "Português",
    matematica: "Matemática",
  },

  radarSeries: "Atividades",

  tooltip: {
    pieFormatterHint: "{{level}} • {{criteria}} • {{count}} alunos ({{pct}}%)",
    avgTimePerWeek: "{{value}} min/semana",
    avgTimeLegend: "Tempo médio",
    barMinute: "{{value}} min",
  },

  studentsTable: {
    student: "Aluno",
    class: "Turma",
    days: "Dias",
    completion: "Conclusão",
    noActivitiesBadge: "sem atividades",
    noAccessRecordBadge: "sem registro de coleta",
    xp: "XP",
  },

  accessLegend: {
    all: "Todos",
    above60: "Acima de 60%",
    between40and60: "40–60%",
    below40: "Abaixo de 40%",
    sortInvert: "Inverter ordem",
  },

  timeBarsLegend: {
    high: "30+ min/sem",
    mid: "20–30 min/sem",
    low: "Abaixo de 20 min",
  },

  turmasOverview: {
    activeClassesTooltip: "Turmas com pelo menos 1 atividade no período.",
    activeClasses: "Turmas ativas",
    withActivityInPeriod: "Com atividade no período",
    allActive: "Todas ativas",
    classesWithoutActivityPlural: "{{count}} turmas sem atividade",
    classesWithoutActivitySingle: "{{count}} turma sem atividade",
    avgCompletion: "Conclusão média",
    vsComparison: "{{value}} pp vs {{comparison}}",
    vsComparisonPercent: "{{value}} vs {{comparison}}",
    turmasRisk: "Turmas em risco",
    riskBelow50: "Acesso abaixo de 50%",
    showMore: "exibir mais",
    showLess: "exibir menos",
    freqAvgPerStudent: "Freq. média / aluno",
    accessPerWeek: "Acessos por semana",
    weeksComparison: "{{value}} vs {{comparison}}",
  },

  tableTurmas: {
    class: "Turma",
    students: "Alunos",
    access: "Acesso",
    completion: "Conclusão",
    freqWeek: "Freq/sem",
    actWeek: "Ativ/sem",
    coinsDistributed: "Moedas distribuídas",
    trend: "Tendência",
    risk: "risco",
    healthy: "Saudável",
    attentionLabel: "Atenção",
    riskLegend: "Risco",
    trendUp: "Subindo",
    trendDown: "Caindo",
    trendStable: "Estável",
  },

  professors: {
    active: "Professores ativos",
    publishedInPeriod: "Publicaram no período",
    activitiesPublished: "Atividades publicadas",
    totalInPeriod: "Total no período",
    avgActPerTeacher: "Média ativ/sem por professor",
    amongActiveTeachers: "Entre professores ativos",
    needSupport: "Precisam de suporte",
    noPublish14: "Sem publicar há 14+ dias",
    colTeacher: "Professor",
    colSuperEngaged: "Super engajados",
    colActivities: "Atividades",
    colActPerWeek: "Ativ/sem",
    avgCompletionCol: "Conclusão média",
    lastAccess: "Último acesso",
    lastPublication: "Última publicação",
    noActivitiesTeacher: "Sem atividades",
    noRecords: "Sem registros",
    daysCount: "{{n}} dias",
    today: "Hoje",
    yesterday: "Ontem",
    daysAgo: "há {{n}} dias",
    profShort: "Prof.",
  },

  skillsMetrics: {
    contentsWorked: "Conteúdos trabalhados",
    activitiesCreated: "Atividades criadas",
    inThisPeriod: "Neste período",
    avgHitRate: "Taxa de acerto média",
    inActivitiesLabel: "Nas atividades",
    studentsReached: "Alunos alcançados",
    withLeastOneActivity: "Com pelo menos 1 atividade",
  },

  reinforcementTable: {
    content: "Conteúdo",
    classCol: "Turma",
    hitRate: "Taxa de acerto",
    strugglingStudents: "Alunos com dificuldade",
    studentsSuffix: "{{n}} alunos",
  },

  rankingRow: {
    activitiesAbbr: "atv.",
  },

  rewards: {
    totalRedemptions: "Total de resgates",
    availableRewards: "Recompensas no catálogo",
    openOrders: "Pedidos em aberto",
    openOrdersHint: "Aguardando aprovação ou entrega",
    studentCol: "Aluno",
    orderCol: "Pedido",
    orderStatusCol: "Status",
    requestedAtCol: "Solicitado em",
    pendingApproval: "Aguardando aprovação",
    acceptedAwaitingDelivery: "Aguardando entrega",
    noOpenOrdersTitle: "Nenhum pedido em aberto",
    noOpenOrdersBody: "Todas as solicitações de recompensa já foram concluídas.",
    exhaustedMany: "{{count}} esgotadas",
    exhaustedOne: "{{count}} esgotada",
    allStock: "Todas com estoque",
    redeemedStudents: "Alunos que já resgataram",
    ofStudents: "{{part}} de {{total}} alunos",
    studentsCount: "{{count}} alunos",
    mostPopular: "Mais popular",
    redemptionsThisPeriod: "{{n}} resgates neste período",
    rewardCol: "Recompensa",
    typeCol: "Tipo",
    redemptionsCol: "Resgates",
    stockCol: "Estoque",
    coinsSpent: "Moedas gastas",
    unlimited: "Ilimitado",
    soldOut: "Esgotado",
    lowStock: "Baixo",
    allRedeemedTitle: "Todos os alunos resgataram no período!",
    allRedeemedBody: "O sistema de recompensas está bem divulgado.",
    nameCol: "Nome",
    coinBalance: "Saldo de moedas",
    highBalance: "Saldo alto",
  },

  rewardTypes: {
    Experiencial: "Experiencial",
    Digital: "Digital",
    Fisica: "Física",
    Outro: "Outro",
  },

  activityTypes: {
    Missao: "Missão",
    Quiz: "Quiz",
    Flashcard: "Flashcard",
  },

  activitiesTab: {
    published: "Atividades publicadas",
    mixLine: "{{missions}} missões + {{quizzes}} quizzes + {{flashcards}} flashcards",
    completionRate: "Taxa de conclusão",
    avgAcrossAll: "Média entre todas atividades",
    quizHitRate: "Taxa de acerto (quizzes)",
    noQuizzes: "Sem quizzes",
    avgCorrectAnswers: "Média de respostas corretas",
    mostPopular: "Mais popular",
    participants: "{{n}} participantes",
    filterAll: "Todos",
    filterMission: "Missão",
    filterQuiz: "Quiz",
    filterFlashcard: "Flashcard",
    tableActivity: "Atividade",
    tableType: "Tipo",
    tableClass: "Turma",
    tableParticipants: "Participantes",
    tableCompletion: "Conclusão",
    tableCorrect: "Acerto",
    legendGood: "Bom (70%+)",
    legendAttention: "Atenção (50–69%)",
    legendCritical: "Crítico (<50%)",
    noDifficultQuizTitle: "Nenhum quiz com dificuldade crítica no período",
    noDifficultQuizBody: "Seus alunos estão mandando bem!",
    difficultLine:
      "{{turma}} • Pergunta mais errada: “{{wrong}}” ({{wrongPct}}% erraram)",
    createRemedialAi: "Criar quiz de reforço com IA",
    vsComparisonActivities: "{{n}} vs {{comparison}}",
    vsComparisonCompletion: "{{n}} pp vs {{comparison}}",
    vsComparisonRedemptions: "{{n}}% vs {{comparison}}",
  },

  engagementLevels: {
    super: {
      label: "Super engajado",
      criteria: "10+ dias de acesso no período",
    },
    engaged: {
      label: "Engajado",
      criteria: "5–9 dias de acesso no período",
    },
    low: {
      label: "Pouco engajado",
      criteria: "1–4 dias de acesso no período",
    },
    inactive: {
      label: "Inativo",
      criteria: "0 dias de acesso no período",
    },
  },

  ordinalRank: "{{n}}°",

  pluralStudents: "{{count}} alunos",
} as const;

/** Broaden string literal leaves so locales can use distinct copy while keeping shape. */
type ReportsDashboardMessagesShape<T> =
  T extends string ? string
  : T extends readonly (infer U)[] ? readonly ReportsDashboardMessagesShape<U>[]
  : T extends Record<string, unknown> ? { [K in keyof T]: ReportsDashboardMessagesShape<T[K]> }
  : T

export type ReportsDashboardMessages =
  ReportsDashboardMessagesShape<typeof reportsDashboardPtBR>

export const reportsDashboardEnUS = {
  classCompletion: {
    "title": "Activities by student",
    "description": "Choose a class, a date range and the activities used for grading. Export one spreadsheet with all students.",
    "class": "Class",
    "period": "Period",
    "selectClass": "Select a class",
    "from": "Start date",
    "to": "End date",
    "load": "Load activities",
    "loading": "Loading…",
    "invalidDates": "Enter valid dates with the end date on or after the start date.",
    "error": "Unable to load activities. Please try again.",
    "emptyActivities": "No activities found for this class in this period.",
    "emptyStudents": "This class has no students.",
    "selectActivities": "Activities included in grading",
    "all": "Select all",
    "none": "Deselect all",
    "selected": "{{selected}} of {{total}} activities selected",
    "export": "Export Excel spreadsheet",
    "student": "Student",
    "completedCount": "Completed",
    "percentage": "Percentage",
    "completed": "Completed",
    "notCompleted": "Not completed",
    "statuses": "Completion",
    "progress": "Progress",
    "exportError": "Unable to export the spreadsheet. Please try again.",
    "criteria": "Students currently in the class. Activities available or performed in the period. Missions: approved submissions; quizzes: submissions, including written answers. Trails and flashcards: completion records in the period. Trail progress: steps completed in the period or final completion. Inclusive dates, Brasília time. Completion is not accuracy or a grade.",
    "types": {
        "mission": "Mission",
        "quiz": "Quiz",
        "trail": "Trail",
        "flashcard": "Flashcards",
        "flashcard_true_false": "True/false flashcards",
        "content": "Content"
    }
},
  pageTitle: "Reports | Gamefik",

  seoDescription:
    "Track engagement, classes, teachers, activities, and rewards in one place.",

  headerTitle: "Reports",
  subtitleGestor: "Whole-school view",
  subtitleProfessor: "Your classes view",
  modeGestor: "Manager",
  modeProfessor: "Teacher",
  export: "Export PDF",
  exportMenu: {
    currentTab: "Export current tab",
    fullReport: "Full report",
    exportDataLabel: "Export data",
    generating: "Generating PDF…",
    failed: "The full report could not be generated because one section failed.",
    generatedAt: "Generated on {{date}}",
    filters: "Period: {{period}} • Class: {{turma}}",
    columnPeriod: "Period",
    columnLevel: "Level",
    columnCount: "Count",
    exportCsvTooltip: "Export CSV: {{table}}",
  },

  periodLabel: "Period:",
  morePeriods: "More periods",

  emptyState: {
    noDataPeriod: "No data found for the selected period",
    refreshing: "Refreshing…",
  },

  classeTodasGestor: "All classes",
  classeTodasProfessor: "All your classes",

  pagination: {
    range: "{{start}}-{{end}} of {{total}}",
  },

  tabs: {
    geral: "Overview",
    turmas: "Classes",
    professores: "Teachers",
    atividades: "Activities",
    recompensas: "Rewards",
  },

  viewModeGestorBadge: "Manager mode — seeing whole-school data",
  viewModeProfessorBadge: "Teacher mode — seeing your classes’ data",

  granularity: {
    days: "days",
    weeks: "weeks",
    months: "months",
    quarters: "quarters",
    bimesters: "terms",
  },

  legend: {
    access: "Access",
    conclusion: "Completion",
    accessRate: "Access rate",
    conclusionRate: "Completion rate",
  },

  period: {
    thisWeek: {
      label: "This week",
      subtitle: "This week (Mon–Wed)",
      comparison: "last week",
      xAxis: "Mon|Tue|Wed",
    },
    thisMonth: {
      label: "This month",
      subtitle: "April 2026",
      comparison: "previous month",
      xAxis: "Wk 1|Wk 2",
    },
    thisTermBimester: {
      label: "This term",
      subtitle: "Term 2, 2026",
      comparison: "previous term",
      xAxis: "Wk 1|Wk 2|Wk 3|Wk 4|Wk 5",
    },
    thisTermTrimester: {
      label: "This trimester",
      subtitle: "Trimester 2, 2026",
      comparison: "previous trimester",
      xAxis: "Wk 1|Wk 2|Wk 3|Wk 4|Wk 5|Wk 6",
    },
    lastWeek: {
      label: "Last week",
      subtitle: "Last week (Apr 7–13)",
      comparison: "the week before",
      xAxis: "Mon|Tue|Wed|Thu|Fri|Sat|Sun",
    },
    lastMonth: {
      label: "Last month",
      subtitle: "March 2026",
      comparison: "previous month",
      xAxis: "Wk 1|Wk 2|Wk 3|Wk 4",
    },
    lastTermBimester: {
      label: "Previous term",
      subtitle: "Term 1, 2026",
      comparison: "previous term",
      xAxis: "Wk 1|Wk 2|Wk 3|Wk 4|Wk 5|Wk 6|Wk 7|Wk 8",
    },
    lastTermTrimester: {
      label: "Previous trimester",
      subtitle: "Trimester 1, 2026",
      comparison: "previous trimester",
      xAxis:
        "Wk 1|Wk 2|Wk 3|Wk 4|Wk 5|Wk 6|Wk 7|Wk 8|Wk 9|Wk 10|Wk 11|Wk 12",
    },
    thisSemester: {
      label: "This semester",
      subtitle: "Semester 1, 2026",
      comparison: "previous semester",
      xAxis: "Feb|Mar|Apr",
    },
    schoolYearBimester: {
      label: "School year",
      subtitle: "School year 2026",
      comparison: "previous school year",
      xAxis: "T1|T2",
    },
    schoolYearTrimester: {
      label: "School year",
      subtitle: "School year 2026",
      comparison: "previous school year",
      xAxis: "Tr1|Tr2",
    },
  },

  metric: {
    studentEngagementTitle: "Student engagement",
    accessRate: "Access rate",
    completionRate: "Completion rate",
    noActivitiesInPeriod: "No activities in this period",
    completionSubtitle: "Completed / assigned activities",
    avgFrequency: "Average frequency",
    avgFrequencySubtitle: "Log-ins per week / student",
    accessOfTotal: "{{access}} of {{total}} students accessed",
  },

  section: {
    weeklyEvolution: "Weekly trend",
    weeklyEvolutionSubtitle: "Access and completion rate by {{grain}}",
    studentEngagementDist: "Student engagement",
    studentEngagementDistSubtitle: "Activity level distribution in the period",
    accessPerClassGestor: "Access by class",
    accessPerClassSubtitleGestor: "Each class access rate — where to intervene",
    accessPerClassSubtitleProfessor: "Access rate for your classes",
    noClassesForFilter: "No classes found for this filter",
    studentsNeedAttention: "Students who need attention",
    studentsNeedAttentionSubtitle: "No access in the selected period",
    topStudents: "Top students",
    topStudentsSubtitle: "Most XP + completed activities",
    highlightWeekTitle: "Weekly highlights",
    highlightWeekBody:
      "Recognizing these students publicly reinforces positive behavior and inspires classmates.",
    atRiskBannerTitle: "{{count}} students need attention",
    atRiskBannerBody:
      "No access in the selected period. A personal message could bring them back.",
    turmasComparison: "Compare classes",
    turmasComparisonSubtitle: "Side-by-side key metrics",
    turmasEvolution: "Trend by class",
    turmasEvolutionSubtitle: "Access rate by {{grain}} for each class",
    studyTimeTitle: "Avg. study time by class",
    studyTimeSubtitle: "Minutes per week per student — sorted by time",
    professorActivityTitle: "Teacher activity",
    professorActivitySubtitle: "How each teacher uses the platform in the period",
    skillsHeroTitle: "Skills & content",
    skillsHeroBody:
      "See which content and skills you worked on most with your students. Spot reinforcement opportunities and performance by class.",
    topContentsRadar: "Most covered content",
    topContentsRadarSubtitle: "Number of activities per topic",
    performanceBySubject: "Performance by subject and class",
    performanceBySubjectSubtitle: "Average quiz score in activities",
    reinforcementTitle: "Content that needs reinforcement",
    reinforcementSubtitle: "Score rate below 60%",
    rankingByActivitiesTitle: "Most worked content",
    rankingByActivitiesSubtitle: "Ranking by number of activities",
    rewardsPerfTitle: "Rewards performance",
    rewardsPerfSubtitle: "Redemptions, stock, and coins spent",
    openRewardOrdersTitle: "Open reward orders",
    openRewardOrdersSubtitle: "Requests awaiting approval or delivery",
    neverRedeemedTitle: "Students with no redemptions in the period",
    neverRedeemedSubtitleSingle:
      "{{count}} student ({{pct}}%) with no redemptions in the period",
    neverRedeemedSubtitlePlural:
      "{{count}} students ({{pct}}%) with no redemptions in the period",
    activitiesPerfTitle: "Activity performance",
    activitiesPerfSubtitle: "All activities in the period",
    difficultQuizzesTitle: "Challenging quizzes",
    difficultQuizzesSubtitle: "Quizzes with a score rate below 70%",
  },

  disciplines: {
    historia: "History",
    geografia: "Geography",
    portugues: "Portuguese",
    matematica: "Math",
  },

  radarSeries: "Activities",

  tooltip: {
    pieFormatterHint: "{{level}} • {{criteria}} • {{count}} students ({{pct}}%)",
    avgTimePerWeek: "{{value}} min/week",
    avgTimeLegend: "Average time",
    barMinute: "{{value}} min",
  },

  studentsTable: {
    student: "Student",
    class: "Class",
    days: "Days",
    completion: "Completion",
    noActivitiesBadge: "no activities",
    noAccessRecordBadge: "no collection record",
    xp: "XP",
  },

  accessLegend: {
    all: "All",
    above60: "Above 60%",
    between40and60: "40–60%",
    below40: "Below 40%",
    sortInvert: "Reverse order",
  },

  timeBarsLegend: {
    high: "30+ min/wk",
    mid: "20–30 min/wk",
    low: "Under 20 min",
  },

  turmasOverview: {
    activeClassesTooltip: "Classes with at least one activity in the period.",
    activeClasses: "Active classes",
    withActivityInPeriod: "With activity in the period",
    allActive: "All active",
    classesWithoutActivitySingle: "{{count}} class inactive",
    classesWithoutActivityPlural: "{{count}} classes inactive",
    avgCompletion: "Average completion",
    vsComparison: "{{value}} pp vs {{comparison}}",
    vsComparisonPercent: "{{value}} vs {{comparison}}",
    turmasRisk: "At-risk classes",
    riskBelow50: "Access below 50%",
    showMore: "show more",
    showLess: "show less",
    freqAvgPerStudent: "Avg. freq / student",
    accessPerWeek: "Log-ins per week",
    weeksComparison: "{{value}} vs {{comparison}}",
  },

  tableTurmas: {
    class: "Class",
    students: "Students",
    access: "Access",
    completion: "Completion",
    freqWeek: "Fq/wk",
    actWeek: "Act/wk",
    coinsDistributed: "Coins distributed",
    trend: "Trend",
    risk: "at risk",
    healthy: "Healthy",
    attentionLabel: "Watch",
    riskLegend: "Risk",
    trendUp: "Up",
    trendDown: "Down",
    trendStable: "Stable",
  },

  professors: {
    active: "Active teachers",
    publishedInPeriod: "Published in the period",
    activitiesPublished: "Activities published",
    totalInPeriod: "Total in the period",
    avgActPerTeacher: "Avg. activities/week per teacher",
    amongActiveTeachers: "Among active teachers",
    needSupport: "Needs support",
    noPublish14: "No publishes for 14+ days",
    colTeacher: "Teacher",
    colSuperEngaged: "Highly engaged",
    colActivities: "Activities",
    colActPerWeek: "Acts/wk",
    avgCompletionCol: "Avg completion",
    lastAccess: "Last access",
    lastPublication: "Last publish",
    noActivitiesTeacher: "No activities",
    noRecords: "No records",
    daysCount: "{{n}} days",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "{{n}} days ago",
    profShort: "Prof.",
  },

  skillsMetrics: {
    contentsWorked: "Topics covered",
    activitiesCreated: "Activities created",
    inThisPeriod: "In this period",
    avgHitRate: "Average score rate",
    inActivitiesLabel: "In activities",
    studentsReached: "Students reached",
    withLeastOneActivity: "With at least one activity",
  },

  reinforcementTable: {
    content: "Topic",
    classCol: "Class",
    hitRate: "Score rate",
    strugglingStudents: "Students struggling",
    studentsSuffix: "{{n}} students",
  },

  rankingRow: {
    activitiesAbbr: "acts",
  },

  rewards: {
    totalRedemptions: "Total redemptions",
    availableRewards: "Rewards in the catalog",
    openOrders: "Open orders",
    openOrdersHint: "Awaiting approval or delivery",
    studentCol: "Student",
    orderCol: "Order",
    orderStatusCol: "Status",
    requestedAtCol: "Requested on",
    pendingApproval: "Awaiting approval",
    acceptedAwaitingDelivery: "Awaiting delivery",
    noOpenOrdersTitle: "No open orders",
    noOpenOrdersBody: "All reward requests have been completed.",
    exhaustedOne: "{{count}} reward out of stock",
    exhaustedMany: "{{count}} rewards out of stock",
    allStock: "All in stock",
    redeemedStudents: "Students who redeemed",
    ofStudents: "{{part}} of {{total}} students",
    studentsCount: "{{count}} students",
    mostPopular: "Most popular",
    redemptionsThisPeriod: "{{n}} redemptions this period",
    rewardCol: "Reward",
    typeCol: "Type",
    redemptionsCol: "Redemptions",
    stockCol: "Stock",
    coinsSpent: "Coins spent",
    unlimited: "Unlimited",
    soldOut: "Sold out",
    lowStock: "Low",
    allRedeemedTitle: "Every student redeemed in the period!",
    allRedeemedBody: "The rewards program is well communicated.",
    nameCol: "Name",
    coinBalance: "Coin balance",
    highBalance: "High balance",
  },

  rewardTypes: {
    Experiencial: "Experiential",
    Digital: "Digital",
    Fisica: "Physical",
    Outro: "Other",
  },

  activityTypes: {
    Missao: "Mission",
    Quiz: "Quiz",
    Flashcard: "Flashcard",
  },

  activitiesTab: {
    published: "Activities published",
    mixLine: "{{missions}} missions + {{quizzes}} quizzes + {{flashcards}} flashcards",
    completionRate: "Completion rate",
    avgAcrossAll: "Average across all activities",
    quizHitRate: "Score rate (quizzes)",
    noQuizzes: "No quizzes",
    avgCorrectAnswers: "Average correct answers",
    mostPopular: "Most popular",
    participants: "{{n}} participants",
    filterAll: "All",
    filterMission: "Mission",
    filterQuiz: "Quiz",
    filterFlashcard: "Flashcard",
    tableActivity: "Activity",
    tableType: "Type",
    tableClass: "Class",
    tableParticipants: "Participants",
    tableCompletion: "Completion",
    tableCorrect: "Score",
    legendGood: "Good (70%+)",
    legendAttention: "Watch (50–69%)",
    legendCritical: "Critical (<50%)",
    noDifficultQuizTitle: "No critically difficult quizzes this period",
    noDifficultQuizBody: "Your students are doing great!",
    difficultLine:
      "{{turma}} • Most missed question: “{{wrong}}” ({{wrongPct}}% missed)",
    createRemedialAi: "Create remedial quiz with AI",
    vsComparisonActivities: "{{n}} vs {{comparison}}",
    vsComparisonCompletion: "{{n}} pp vs {{comparison}}",
    vsComparisonRedemptions: "{{n}}% vs {{comparison}}",
  },

  engagementLevels: {
    super: {
      label: "Highly engaged",
      criteria: "10+ access days in period",
    },
    engaged: {
      label: "Engaged",
      criteria: "5–9 access days in period",
    },
    low: {
      label: "Low engagement",
      criteria: "1–4 access days in period",
    },
    inactive: {
      label: "Inactive",
      criteria: "0 access days in period",
    },
  },

  ordinalRank: "#{{n}}",

  pluralStudents: "{{count}} students",
} satisfies ReportsDashboardMessages;

export const reportsDashboardEsES = {
  classCompletion: {
    "title": "Actividades por alumno",
    "description": "Seleccione una clase, el período y las actividades que cuentan para la nota. Exporte una sola hoja de cálculo con todos los alumnos.",
    "class": "Clase",
    "period": "Período",
    "selectClass": "Seleccione una clase",
    "from": "Fecha inicial",
    "to": "Fecha final",
    "load": "Consultar actividades",
    "loading": "Cargando…",
    "invalidDates": "Introduzca fechas válidas, con la fecha final igual o posterior a la inicial.",
    "error": "No se pudieron consultar las actividades. Inténtelo de nuevo.",
    "emptyActivities": "No se encontraron actividades para esta clase en el período.",
    "emptyStudents": "Esta clase no tiene alumnos.",
    "selectActivities": "Actividades incluidas en la nota",
    "all": "Seleccionar todas",
    "none": "Desmarcar todas",
    "selected": "{{selected}} de {{total}} actividades seleccionadas",
    "export": "Exportar hoja de cálculo Excel",
    "student": "Alumno",
    "completedCount": "Completadas",
    "percentage": "Porcentaje",
    "completed": "Completado",
    "notCompleted": "No completado",
    "statuses": "Finalización",
    "progress": "Progreso",
    "exportError": "No se pudo exportar la hoja de cálculo. Inténtelo de nuevo.",
    "criteria": "Alumnos actualmente en la clase. Actividades disponibles o realizadas en el período. Misiones: envíos aprobados; quizzes: envíos, incluidas respuestas escritas. Rutas y flashcards: registros de finalización en el período. Progreso de la ruta: etapas completadas en el período o finalización. Fechas inclusivas, hora de Brasilia. Finalización no representa aciertos ni nota.",
    "types": {
        "mission": "Misión",
        "quiz": "Quiz",
        "trail": "Ruta",
        "flashcard": "Flashcards",
        "flashcard_true_false": "Flashcards V/F",
        "content": "Contenido"
    }
},
  pageTitle: "Informes | Gamefik",

  seoDescription:
    "Sigue el engagement, clases, profesores, actividades y recompensas en un solo lugar.",

  headerTitle: "Informes",
  subtitleGestor: "Vista de toda la escuela",
  subtitleProfessor: "Vista de tus clases",
  modeGestor: "Gestor",
  modeProfessor: "Profesor",
  export: "Exportar PDF",
  exportMenu: {
    currentTab: "Exportar pestaña actual",
    fullReport: "Informe completo",
    exportDataLabel: "Exportar datos",
    generating: "Generando PDF…",
    failed: "No se pudo generar el informe completo porque una sección falló.",
    generatedAt: "Generado el {{date}}",
    filters: "Período: {{period}} • Clase: {{turma}}",
    columnPeriod: "Período",
    columnLevel: "Nivel",
    columnCount: "Cantidad",
    exportCsvTooltip: "Exportar CSV: {{table}}",
  },

  periodLabel: "Período:",
  morePeriods: "Más períodos",

  emptyState: {
    noDataPeriod: "No se encontraron datos para el período seleccionado",
    refreshing: "Actualizando…",
  },

  classeTodasGestor: "Todas las clases",
  classeTodasProfessor: "Todas tus clases",

  pagination: {
    range: "{{start}}-{{end}} de {{total}}",
  },

  tabs: {
    geral: "General",
    turmas: "Clases",
    professores: "Profesores",
    atividades: "Actividades",
    recompensas: "Recompensas",
  },

  viewModeGestorBadge: "Modo gestor — viendo datos de toda la escuela",
  viewModeProfessorBadge: "Modo profesor — viendo datos de tus clases",

  granularity: {
    days: "días",
    weeks: "semanas",
    months: "meses",
    quarters: "trimestres",
    bimesters: "bimestres",
  },

  legend: {
    access: "Acceso",
    conclusion: "Finalización",
    accessRate: "Tasa de acceso",
    conclusionRate: "Tasa de finalización",
  },

  period: {
    thisWeek: {
      label: "Esta semana",
      subtitle: "Esta semana (lun–mié)",
      comparison: "la semana pasada",
      xAxis: "Lun|Mar|Mié",
    },
    thisMonth: {
      label: "Este mes",
      subtitle: "Abril 2026",
      comparison: "mes anterior",
      xAxis: "Sem 1|Sem 2",
    },
    thisTermBimester: {
      label: "Este bimestre",
      subtitle: "2.º bimestre 2026",
      comparison: "bimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5",
    },
    thisTermTrimester: {
      label: "Este trimestre",
      subtitle: "2.º trimestre 2026",
      comparison: "trimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5|Sem 6",
    },
    lastWeek: {
      label: "Última semana",
      subtitle: "Última semana (7–13 abr)",
      comparison: "semana anterior",
      xAxis: "Lun|Mar|Mié|Jue|Vie|Sáb|Dom",
    },
    lastMonth: {
      label: "Último mes",
      subtitle: "Marzo 2026",
      comparison: "mes anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4",
    },
    lastTermBimester: {
      label: "Último bimestre",
      subtitle: "1.º bimestre 2026",
      comparison: "bimestre anterior",
      xAxis: "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5|Sem 6|Sem 7|Sem 8",
    },
    lastTermTrimester: {
      label: "Último trimestre",
      subtitle: "1.º trimestre 2026",
      comparison: "trimestre anterior",
      xAxis:
        "Sem 1|Sem 2|Sem 3|Sem 4|Sem 5|Sem 6|Sem 7|Sem 8|Sem 9|Sem 10|Sem 11|Sem 12",
    },
    thisSemester: {
      label: "Este semestre",
      subtitle: "1.º semestre 2026",
      comparison: "semestre anterior",
      xAxis: "Feb|Mar|Abr",
    },
    schoolYearBimester: {
      label: "Año lectivo",
      subtitle: "Año lectivo 2026",
      comparison: "año anterior",
      xAxis: "1.º Bi|2.º Bi",
    },
    schoolYearTrimester: {
      label: "Año lectivo",
      subtitle: "Año lectivo 2026",
      comparison: "año anterior",
      xAxis: "1.º Tri|2.º Tri",
    },
  },

  metric: {
    studentEngagementTitle: "Compromiso de los alumnos",
    accessRate: "Tasa de acceso",
    completionRate: "Tasa de finalización",
    noActivitiesInPeriod: "Sin actividades en el período",
    completionSubtitle: "Actividades completadas / asignadas",
    avgFrequency: "Frecuencia media",
    avgFrequencySubtitle: "Accesos por semana / alumno",
    accessOfTotal: "{{access}} de {{total}} alumnos accedieron",
  },

  section: {
    weeklyEvolution: "Evolución semanal",
    weeklyEvolutionSubtitle: "Tasa de acceso y finalización por {{grain}}",
    studentEngagementDist: "Compromiso de tus alumnos",
    studentEngagementDistSubtitle: "Distribución por nivel de actividad en el período",
    accessPerClassGestor: "Acceso por clase",
    accessPerClassSubtitleGestor:
      "Tasa de acceso de cada clase — identifica dónde actuar",
    accessPerClassSubtitleProfessor: "Tasa de acceso de tus clases",
    noClassesForFilter: "No se encontraron clases para este filtro",
    studentsNeedAttention: "Alumnos que necesitan atención",
    studentsNeedAttentionSubtitle: "Sin acceso en el período seleccionado",
    topStudents: "Alumnos destacados",
    topStudentsSubtitle: "Más XP + actividades completadas",
    highlightWeekTitle: "Destacados de la semana",
    highlightWeekBody:
      "Reconocer a estos alumnos refuerza el comportamiento positivo e inspira al resto.",
    atRiskBannerTitle: "{{count}} alumnos necesitan atención",
    atRiskBannerBody:
      "Sin acceso en el período seleccionado. Un mensaje personal puede volver a conectarlos.",
    turmasComparison: "Comparativo entre clases",
    turmasComparisonSubtitle: "Métricas clave lado a lado",
    turmasEvolution: "Evolución por clase",
    turmasEvolutionSubtitle: "Tasa de acceso por {{grain}} de cada clase",
    studyTimeTitle: "Tiempo medio de estudio por clase",
    studyTimeSubtitle: "Minutos por semana por alumno — ordenado por tiempo",
    professorActivityTitle: "Actividad de los profesores",
    professorActivitySubtitle:
      "Cómo cada profesor usa la plataforma en el período",
    skillsHeroTitle: "Habilidades y contenidos",
    skillsHeroBody:
      "Sigue con qué contenidos trabajaste más con tus alumnos. Detecta refuerzos y el desempeño por clase.",
    topContentsRadar: "Contenidos más trabajados",
    topContentsRadarSubtitle: "Cantidad de actividades por contenido",
    performanceBySubject: "Desempeño por materia y clase",
    performanceBySubjectSubtitle: "Promedio de aciertos en actividades",
    reinforcementTitle: "Contenidos que necesitan refuerzo",
    reinforcementSubtitle: "Tasa de acierto por debajo del 60%",
    rankingByActivitiesTitle: "Contenidos más trabajados",
    rankingByActivitiesSubtitle: "Ranking por cantidad de actividades",
    rewardsPerfTitle: "Desempeño de las recompensas",
    rewardsPerfSubtitle: "Canjes, stock y monedas gastadas",
    openRewardOrdersTitle: "Pedidos de recompensas abiertos",
    openRewardOrdersSubtitle: "Solicitudes pendientes de aprobación o entrega",
    neverRedeemedTitle: "Alumnos sin canjes en el período",
    neverRedeemedSubtitleSingle:
      "{{count}} alumno ({{pct}}%) sin canjes en el período",
    neverRedeemedSubtitlePlural:
      "{{count}} alumnos ({{pct}}%) sin canjes en el período",
    activitiesPerfTitle: "Desempeño de las actividades",
    activitiesPerfSubtitle: "Todas las actividades del período",
    difficultQuizzesTitle: "Quizzes difíciles",
    difficultQuizzesSubtitle: "Quizzes con tasa de acierto menor al 70%",
  },

  disciplines: {
    historia: "Historia",
    geografia: "Geografía",
    portugues: "Portugués",
    matematica: "Matemáticas",
  },

  radarSeries: "Actividades",

  tooltip: {
    pieFormatterHint: "{{level}} • {{criteria}} • {{count}} alumnos ({{pct}}%)",
    avgTimePerWeek: "{{value}} min/semana",
    avgTimeLegend: "Tiempo medio",
    barMinute: "{{value}} min",
  },

  studentsTable: {
    student: "Alumno",
    class: "Clase",
    days: "Días",
    completion: "Finalización",
    noActivitiesBadge: "sin actividades",
    noAccessRecordBadge: "sin registro de recolección",
    xp: "XP",
  },

  accessLegend: {
    all: "Todos",
    above60: "Por encima del 60%",
    between40and60: "40–60%",
    below40: "Por debajo del 40%",
    sortInvert: "Invertir orden",
  },

  timeBarsLegend: {
    high: "+30 min/sem",
    mid: "20–30 min/sem",
    low: "Menos de 20 min",
  },

  turmasOverview: {
    activeClassesTooltip: "Clases con al menos 1 actividad en el período.",
    activeClasses: "Clases activas",
    withActivityInPeriod: "Con actividad en el período",
    allActive: "Todas activas",
    classesWithoutActivitySingle: "{{count}} clase sin actividad",
    classesWithoutActivityPlural: "{{count}} clases sin actividad",
    avgCompletion: "Finalización media",
    vsComparison: "{{value}} pp vs {{comparison}}",
    vsComparisonPercent: "{{value}} vs {{comparison}}",
    turmasRisk: "Clases en riesgo",
    riskBelow50: "Acceso por debajo del 50%",
    showMore: "mostrar más",
    showLess: "mostrar menos",
    freqAvgPerStudent: "Freq. media / alumno",
    accessPerWeek: "Accesos por semana",
    weeksComparison: "{{value}} vs {{comparison}}",
  },

  tableTurmas: {
    class: "Clase",
    students: "Alumnos",
    access: "Acceso",
    completion: "Finalización",
    freqWeek: "Freq/sem",
    actWeek: "Act/sem",
    coinsDistributed: "Monedas distribuidas",
    trend: "Tendencia",
    risk: "riesgo",
    healthy: "Saludable",
    attentionLabel: "Atención",
    riskLegend: "Riesgo",
    trendUp: "Sube",
    trendDown: "Baja",
    trendStable: "Estable",
  },

  professors: {
    active: "Profesores activos",
    publishedInPeriod: "Publicaron en el período",
    activitiesPublished: "Actividades publicadas",
    totalInPeriod: "Total en el período",
    avgActPerTeacher: "Media act/sem por profesor",
    amongActiveTeachers: "Entre profesores activos",
    needSupport: "Necesitan apoyo",
    noPublish14: "Sin publicar hace 14+ días",
    colTeacher: "Profesor",
    colSuperEngaged: "Muy comprometidos",
    colActivities: "Actividades",
    colActPerWeek: "Act/sem",
    avgCompletionCol: "Finalización media",
    lastAccess: "Último acceso",
    lastPublication: "Última publicación",
    noActivitiesTeacher: "Sin actividades",
    noRecords: "Sin registros",
    daysCount: "{{n}} días",
    today: "Hoy",
    yesterday: "Ayer",
    daysAgo: "hace {{n}} días",
    profShort: "Prof.",
  },

  skillsMetrics: {
    contentsWorked: "Contenidos trabajados",
    activitiesCreated: "Actividades creadas",
    inThisPeriod: "En este período",
    avgHitRate: "Tasa media de aciertos",
    inActivitiesLabel: "En las actividades",
    studentsReached: "Alumnos alcanzados",
    withLeastOneActivity: "Con al menos 1 actividad",
  },

  reinforcementTable: {
    content: "Contenido",
    classCol: "Clase",
    hitRate: "Tasa de acierto",
    strugglingStudents: "Alumnos con dificultad",
    studentsSuffix: "{{n}} alumnos",
  },

  rankingRow: {
    activitiesAbbr: "act.",
  },

  rewards: {
    totalRedemptions: "Total de canjes",
    availableRewards: "Recompensas en el catálogo",
    openOrders: "Pedidos abiertos",
    openOrdersHint: "Pendientes de aprobación o entrega",
    studentCol: "Alumno",
    orderCol: "Pedido",
    orderStatusCol: "Estado",
    requestedAtCol: "Solicitado el",
    pendingApproval: "Pendiente de aprobación",
    acceptedAwaitingDelivery: "Pendiente de entrega",
    noOpenOrdersTitle: "No hay pedidos abiertos",
    noOpenOrdersBody: "Todas las solicitudes de recompensa ya se completaron.",
    exhaustedOne: "{{count}} agotada",
    exhaustedMany: "{{count}} agotadas",
    allStock: "Todas con stock",
    redeemedStudents: "Alumnos que ya canjearon",
    ofStudents: "{{part}} de {{total}} alumnos",
    studentsCount: "{{count}} alumnos",
    mostPopular: "Más popular",
    redemptionsThisPeriod: "{{n}} canjes en este período",
    rewardCol: "Recompensa",
    typeCol: "Tipo",
    redemptionsCol: "Canjes",
    stockCol: "Stock",
    coinsSpent: "Monedas gastadas",
    unlimited: "Ilimitado",
    soldOut: "Agotado",
    lowStock: "Bajo",
    allRedeemedTitle: "¡Todos los alumnos canjearon en el período!",
    allRedeemedBody: "El sistema de recompensas está bien comunicado.",
    nameCol: "Nombre",
    coinBalance: "Saldo de monedas",
    highBalance: "Saldo alto",
  },

  rewardTypes: {
    Experiencial: "Experiencial",
    Digital: "Digital",
    Fisica: "Física",
    Outro: "Otro",
  },

  activityTypes: {
    Missao: "Misión",
    Quiz: "Quiz",
    Flashcard: "Tarjetas",
  },

  activitiesTab: {
    published: "Actividades publicadas",
    mixLine:
      "{{missions}} misiones + {{quizzes}} quizzes + {{flashcards}} tarjetas",
    completionRate: "Tasa de finalización",
    avgAcrossAll: "Media entre todas las actividades",
    quizHitRate: "Tasa de aciertos (quizzes)",
    noQuizzes: "Sin quizzes",
    avgCorrectAnswers: "Respuestas correctas en media",
    mostPopular: "Más popular",
    participants: "{{n}} participantes",
    filterAll: "Todos",
    filterMission: "Misión",
    filterQuiz: "Quiz",
    filterFlashcard: "Tarjetas",
    tableActivity: "Actividad",
    tableType: "Tipo",
    tableClass: "Clase",
    tableParticipants: "Participantes",
    tableCompletion: "Finalización",
    tableCorrect: "Acerto",
    legendGood: "Bueno (70%+)",
    legendAttention: "Atención (50–69%)",
    legendCritical: "Crítico (<50%)",
    noDifficultQuizTitle: "Sin quizzes críticamente difíciles en el período",
    noDifficultQuizBody: "¡Tus alumnos lo están haciendo muy bien!",
    difficultLine:
      "{{turma}} • Pregunta más errada: «{{wrong}}» ({{wrongPct}}% fallaron)",
    createRemedialAi: "Crear quiz de refuerzo con IA",
    vsComparisonActivities: "{{n}} vs {{comparison}}",
    vsComparisonCompletion: "{{n}} pp vs {{comparison}}",
    vsComparisonRedemptions: "{{n}}% vs {{comparison}}",
  },

  engagementLevels: {
    super: {
      label: "Muy comprometido",
      criteria: "10+ días de acceso en el período",
    },
    engaged: {
      label: "Comprometido",
      criteria: "5–9 días de acceso en el período",
    },
    low: {
      label: "Poco comprometido",
      criteria: "1–4 días de acceso en el período",
    },
    inactive: {
      label: "Inactivo",
      criteria: "0 días de acceso en el período",
    },
  },

  ordinalRank: "{{n}}.º",

  pluralStudents: "{{count}} alumnos",
} satisfies ReportsDashboardMessages;
